<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'

export default {
    mixins: [messages],
    data() {
        return {
            newPassword: '',
            newPasswordConfirm: ''
        }
    },
    props: {
        userResource: {
            type: Object,
            required: true
        }
    },
    methods: {
        async onSubmit() {
            try {
                let user = await this.userResource.setPassword(this.newPassword)
                this.$emit('success', user)
            } catch(e) {
                throw this.axiosExtract(e)
            }
        },
        isValid() {
            return this.newPassword && this.newPassword === this.newPasswordConfirm
        }
    },
}
</script>

<template>
    <b-form class="horizontal" @submit.prevent="onSubmit">
        <b-card class="mt-5" :header="!userResource.isOnboarded() ? 'Passwort festlegen' : 'Passwort ändern'">
            <b-alert variant="success" v-if="!userResource.isOnboarded()" show>Sie haben noch kein Passwort festgelegt</b-alert>
            <b-form-group label="Neues Passwort:">
                <b-form-input type="password" v-model="newPassword" autocomplete="new-password" />
            </b-form-group>
            <b-form-group label="Neues Passwort (nochmal):">
                <b-form-input type="password" v-model="newPasswordConfirm" autocomplete="new-password" />
            </b-form-group>
            <messages />
            <template slot="footer">
                <b-button :to="{ name: 'dashboard' }" variant="link" size="sm">Abbrechen</b-button>
                <b-button type="submit" :disabled="!isValid()" class="float-right">Absenden</b-button>
            </template>
        </b-card>
    </b-form>
</template>